var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReminderImg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 86,
    viewBox: "0 0 105 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M33.865 11.1218C14.9461 19.922 8.316 43.8062 20.09 60.9871C25.3861 68.7027 34.8147 75.16 51.5477 75.2648C98.7126 75.5505 103.954 52.8161 101.841 34.1166C99.6442 14.7084 60.052 -1.05525 33.865 11.1218Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5781 67.542L55.0209 84.9254H81.516L76.0133 70.6007L53.5781 67.542Z",
    fill: "#24285B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.763 47.2119C44.763 47.2119 36.4255 61.8078 43.7625 67.0575C51.0995 72.3073 57.2148 60.5966 57.2148 60.5966L44.763 47.2119Z",
    fill: "#F4A28C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.8235 47.1758C44.8235 47.1758 36.486 61.7716 43.823 67.0214C51.16 72.2711 57.2754 60.5604 57.2754 60.5604L44.8235 47.1758Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5308 15.2285L69.8576 24.3866L63.2891 24.571L65.0689 15.9082L68.5308 15.2285Z",
    fill: "#F4A28C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M64.5968 17.7882C65.4302 17.6374 66.2005 17.2451 66.8117 16.6602C66.8117 16.6602 66.5905 18.8295 64.082 20.818L64.5968 17.7882Z",
    fill: "#CE8172"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1832 12.1337C61.1832 12.1337 61.8321 15.695 63.0501 17.8499C63.1676 18.0594 63.3257 18.2435 63.5153 18.3913C63.7048 18.5392 63.922 18.648 64.1542 18.7113C64.3864 18.7745 64.6288 18.7911 64.8675 18.7599C65.1061 18.7287 65.3361 18.6504 65.5441 18.5296C66.6316 17.9005 67.8967 16.7218 67.7843 14.7912L67.9946 11.4576C67.9946 11.4576 68.0562 9.36064 65.6963 8.48207C63.3365 7.6035 60.6793 9.98613 61.1832 12.1337Z",
    fill: "#F4A28C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7086 14.3574L61.0996 15.9663C61.0652 16.0579 61.0545 16.1566 61.0685 16.2534C61.0824 16.3502 61.1206 16.4419 61.1795 16.5201C61.2384 16.5983 61.316 16.6604 61.4053 16.7007C61.4946 16.7411 61.5927 16.7583 61.6904 16.7509L63.0969 16.6388L61.7086 14.3574Z",
    fill: "#F4A28C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2899 24.5711L69.8584 24.3867C69.8584 24.3867 85.0218 24.5747 87.2584 37.352C89.495 50.1292 76.0209 70.6148 76.0209 70.6148L53.5858 67.5561C53.5858 67.5561 51.5993 55.1982 50.7764 44.3589C49.9535 33.5195 51.7008 26.7477 63.2899 24.5711Z",
    fill: "rgba(38, 127, 215, 1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1824 12.134C60.6326 10.84 59.9002 9.63098 59.0074 8.54375C58.7663 8.25167 58.6061 7.90181 58.5425 7.52889C58.4789 7.15597 58.5142 6.77294 58.6449 6.41782C59.2647 4.38228 61.3709 6.41782 62.7737 4.80891C64.1766 3.2 65.5034 3.2 66.6271 4.44736C67.7509 5.69471 67.2796 6.67452 68.9326 6.46482C70.5856 6.25512 71.365 8.68475 69.509 9.37893C67.653 10.0731 68.5266 15.2144 68.5266 15.2144L67.1382 15.4892L66.8337 15.0589C66.2775 14.3173 65.5954 13.6785 64.8182 13.1716C64.4376 12.9041 64.1512 12.3617 64.5319 11.2445L61.1824 12.134Z",
    fill: "#24285B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9558 31.6013L50.0859 31.5915C50.2901 31.5761 50.4921 31.6422 50.6474 31.7753C50.8027 31.9084 50.8986 32.0976 50.9141 32.3012L51.5682 40.9177L49.9019 41.0435L49.2477 32.4271C49.2323 32.224 49.2982 32.0232 49.4308 31.8684C49.5635 31.7137 49.7523 31.6176 49.9558 31.6013Z",
    fill: "#24285B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8945 41.0504L50.8842 43.0498L51.562 40.9238L49.8945 41.0504Z",
    fill: "#24285B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1315 14.8275C66.1315 14.8275 65.7908 13.4753 66.8311 13.3054C67.8715 13.1355 68.379 15.0806 67.0523 15.6374L66.1315 14.8275Z",
    fill: "#F4A28C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M75.4374 30.9629C75.4374 30.9629 67.5313 33.3238 67.5603 44.3403C67.5893 55.3568 65.4361 63.2206 61.8364 61.9552C58.2368 60.6897 52.2266 58.0685 52.2266 58.0685L53.5787 67.5448L67.4516 69.4465L74.5276 64.2293L82.0567 48.8163L75.4374 30.9629Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7861 39.2467C45.7861 39.2467 45.3475 33.9355 49.6358 34.1199C53.9242 34.3043 52.3365 39.2106 45.7861 39.2467Z",
    fill: "#F4A28C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8048 30.9238C87.7048 34.7382 89.6188 41.5137 85.5733 53.3075L71.8164 49.9776C71.8164 49.9776 71.878 40.0494 74.6258 32.4713C74.9873 31.4854 75.6078 30.6146 76.4224 29.9499C77.2369 29.2852 78.2157 28.851 79.2561 28.6929C80.2966 28.5347 81.3605 28.6583 82.3366 29.0508C83.3128 29.4432 84.1652 30.0902 84.8048 30.9238Z",
    fill: "rgba(38, 127, 215, 1)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6013 36.316L41.9375 40.3682L50.2235 53.9233L56.8873 49.8711L48.6013 36.316Z",
    fill: "#FFD200"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M48.6013 36.316L41.9375 40.3682L50.2235 53.9233L56.8873 49.8711L48.6013 36.316Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0198 51.0152L48.7522 54.826L40.0703 41.51L46.7331 37.457L55.0198 51.0152Z",
    fill: "#FFD200"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M65.0938 69.1113L69.857 84.9256H81.515L77.0019 73.1788L65.0938 69.1113Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M84.8048 30.9238C87.7048 34.7382 89.6188 41.5137 85.5733 53.3075L71.8164 49.9776C71.8164 49.9776 71.878 40.0494 74.6258 32.4713C74.9873 31.4854 75.6078 30.6146 76.4224 29.9499C77.2369 29.2852 78.2157 28.851 79.2561 28.6929C80.2966 28.5347 81.3605 28.6583 82.3366 29.0508C83.3128 29.4432 84.1652 30.0902 84.8048 30.9238Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7985 53.1195C84.7985 53.1195 82.6743 72.7338 74.4782 74.3354C69.8672 75.2357 47.6713 53.7956 47.6713 53.7956C47.6713 53.7956 43.865 54.1174 42.8283 49.4317C41.7915 44.746 51.3942 51.1093 51.3942 51.1093C51.3942 51.1093 68.9174 64.7145 71.4042 62.0318C73.8909 59.3491 73.242 50.3247 73.242 50.3247L84.7985 53.1195Z",
    fill: "#F4A28C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0709 41.51C40.0709 41.51 41.2382 49.2111 39.2988 54.4283L48.5281 53.6365C48.5281 53.6365 50.5835 46.4054 46.7337 37.457L40.0709 41.51Z",
    fill: "#FFD200"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.0709 41.51C40.0709 41.51 41.2382 49.2111 39.2988 54.4283L48.5281 53.6365C48.5281 53.6365 50.5835 46.4054 46.7337 37.457L40.0709 41.51Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6582 24.925C61.6582 24.925 60.549 21.9675 65.044 21.6313C69.539 21.295 73.4721 20.7672 73.5627 24.8455C73.5627 24.8455 67.538 26.834 61.6582 24.925Z",
    fill: "rgba(38, 127, 215, 1)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.44,
    d: "M61.6582 24.925C61.6582 24.925 60.549 21.9675 65.044 21.6313C69.539 21.295 73.4721 20.7672 73.5627 24.8455C73.5627 24.8455 67.538 26.834 61.6582 24.925Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4662 27.2717C41.2961 27.2717 46.0222 22.5579 46.0222 16.7432C46.0222 10.9286 41.2961 6.21484 35.4662 6.21484C29.6362 6.21484 24.9102 10.9286 24.9102 16.7432C24.9102 22.5579 29.6362 27.2717 35.4662 27.2717Z",
    fill: "#C1C1C1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.467 24.4736C39.7474 24.4736 43.2173 21.0128 43.2173 16.7437C43.2173 12.4745 39.7474 9.01367 35.467 9.01367C31.1867 9.01367 27.7168 12.4745 27.7168 16.7437C27.7168 21.0128 31.1867 24.4736 35.467 24.4736Z",
    fill: "#E6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4668 12.0938V16.7433L38.3922 18.7716",
    stroke: "#878787",
    strokeWidth: 3.045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.883 21.7871H3.5625V37.9485H35.883V21.7871Z",
    fill: "#EFEFEF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2847 25.7539H20.623V28.621H32.2847V25.7539Z",
    fill: "#C1C1C1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M32.2847 30.9629H20.623V33.83H32.2847V30.9629Z",
    fill: "#C1C1C1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7859 34.1163C15.1023 34.1163 16.98 32.2435 16.98 29.9332C16.98 27.6229 15.1023 25.75 12.7859 25.75C10.4696 25.75 8.5918 27.6229 8.5918 29.9332C8.5918 32.2435 10.4696 34.1163 12.7859 34.1163Z",
    fill: "#C1C1C1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReminderImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reminder-img.bebeec0f598d1dcf66dbf1fe3b9c758f.svg";